import proj3Imagen from "../assets/img/sem.png";
import proj10Imagen from "../assets/img/fizh&chipss-2.png";
import proj12Imagen from "../assets/img/EnergySysteem-2.png";
import proj15Imagen from "../assets/img/cogs.png";
import proj16Imagen from "../assets/img/chimpaquiz.png";
import proj17Imagen from "../assets/img/chatbot-proj-img.png";

//Project AI
import flask from "../assets/img/flask.svg";
import tensorflow from "../assets/img/tensorflow.svg";
import python from "../assets/img/python.svg";
import rasa from "../assets/img/rasa.svg";
//Project Web
import csharp from "../assets/img/csharp.svg";
//Project Blockchain
import nodejs from "../assets/img/nodejs.svg";
import reactjs from "../assets/img/reactjs.svg";
import ipfs from "../assets/img/ipfs.svg";

//Project Unity Game
import unity from "../assets/img/unity.svg";
//Project Fizh&Chips
import cplus from "../assets/img/cplus.svg";
import cmake from "../assets/img/cmake.svg";
//Project game engineering
import java from "../assets/img/java.svg";
import firebase from "../assets/img/firebase.svg";
//Project software engineering methods
import docker from "../assets/img/docker.svg";
import mysql from "../assets/img/mysql.svg";

//Project assembly
import ecg from "../assets/img/ecg.png"

const timelineElements = [
 
    {
        date: 'January 2026 - Present',
        title: 'Software Developer at Plexus Tech',
        description: 'Currently working at Plexus Tech as a Junior Software Developer, started January 2026 on hybrid position, based on Milton Keynes near London.',
        imgUrl: null,
        technologies: ['Java', 'Git', 'Bitbucket', 'Confluence', 'AGILE', 'SOLID', 'CI/CD', 'Branch Strategy'],
        tech_definitions: {
            'Java': "A high-level, object-oriented programming language widely used for building enterprise applications.",
            'Git': "A distributed version control system for tracking changes in source code during software development.",
            'Bitbucket': "A Git-based source code repository hosting service owned by Atlassian, used for version control and collaboration.",
            'Confluence': "A collaboration tool developed by Atlassian for creating, sharing, and collaborating on project documentation and knowledge bases.",
            'AGILE': "An iterative approach to project management and software development that emphasizes flexibility and collaboration.",
            'SOLID': "A set of design principles for writing maintainable and extensible software: Single Responsibility, Open-Closed, Liskov Substitution, Interface Segregation, and Dependency Inversion.",
            'CI/CD': "Continuous Integration and Continuous Deployment practices for automating the software release process.",
            'Branch Strategy': "A versioning workflow that defines how branches are created, merged, and managed in a Git repository."
        },
        languages_frameworks: [],
        additionalLinks: [],
        showInProjects: false
    },
    {
        date: 'September 2024',
        title: 'ECG Analyser',
        description: 'A machine learning-based ECG analyser that processes and classifies electrocardiogram (ECG) signals using a 1D Convolutional Neural Network (1D-CNN). The model is trained on CSV-based ECG datasets to detect and classify heart conditions as normal or abnormal. The system is built using Python and Flask for backend processing, React for the frontend, and CSV for structured data input. The trained 1D-CNN model extracts important features from ECG waveforms, enabling accurate classification of heart conditions. The code structure includes a React front-end with components for upload, analysis, and results; a Flask back-end with API endpoints for model inference; and a training script for building the ML models using Keras and TensorFlow.',
        imgUrl: ecg,
        technologies: ['Python', 'Flask', 'Machine Learning', 'ML', 'React', 'CSV', 'ECG Analysis', '1D-CNN','CNN','Convolutional Neural Network'],
        tech_definitions: {
            'Python': "A high-level, interpreted programming language widely used for data processing, machine learning, and backend development.",
            'Flask': "A lightweight web framework for Python, enabling backend processing and API communication.",
            'Machine Learning': "A subset of artificial intelligence focused on training models to learn patterns from ECG data for classification.",
            'React': "A JavaScript library used for building dynamic and interactive user interfaces for ECG visualization.",
            'CSV': "A file format (Comma-Separated Values) used for storing and handling structured ECG datasets.",
            'ECG Analysis': "The process of examining electrocardiogram signals to detect abnormalities and classify heart conditions.",
            '1D-CNN': "A type of Convolutional Neural Network designed to process sequential data, such as ECG signals, by extracting temporal patterns for classification."
        },
        languages_frameworks: [python, flask, reactjs, tensorflow],
        additionalLinks: [
            {
                url: "https://github.com/Carlosjr5/ecg-analyzer.git",
                text: "Github Repo",
            },

        ],
    },
    {
        date: 'April 2024',
        title: 'Machine Learning for Conversational AI',
        description: 'AI-powered Chatbot to help students choose a career in Computing Science, providing information about the learning outcomes, career future as well as providing a link to find where to apply to the related course.',
        imgUrl: proj17Imagen,
        technologies: ['Python', 'NLP', 'NLU', 'AI'],
        tech_definitions: {
            'Python': "A high-level, interpreted programming language valued for its simplicity and readability.",
            'NLP': "A branch of artificial intelligence concerned with enabling computers to understand, interpret, and generate human language.",
            'NLU': "A subfield of NLP focused on enabling computers to comprehend the meaning and intent behind human language.",
            'AI': "The simulation of human intelligence processes by machines, including learning, reasoning, and self-correction.",
            'ML': "The study of algorithms and statistical models that enable computers to perform tasks without explicit instructions, relying on patterns and inference instead."
        },
        languages_frameworks: [python, rasa],
        additionalLinks: [
            {
                url: "https://github.com/Carlosjr5/Career-Advisor-Bot.git",
                text: "Github Repo",
            },

        ],
    },
    {
        key: '2',
        date: 'June 2023',
        icon: 'briefcase',
        location: 'Company Name',
        title: 'Full-Stack Development of a Blockchain Network',
        description: 'This project is a study for a document and an implementation of blockchain network with certain capabilities aiming to have a well secured and structured blockchain algorithm which holds transactions, and it can validate transaction to add them to the block within different nodes/peers in the network, which will be saved as known wallet between them, as well has several features, such as for chatting and playing a battleship game, in order to developed this system have used NodeJS, React, IPFS...',
        imgUrl: proj15Imagen,
        technologies: ['NodeJS', 'React', 'Blockchain', 'Cryptocurrency', 'Cryptography', 'SHA-256', 'IPFS', 'WEB3'],
        tech_definitions: {
            'NodeJS': "An open-source, cross-platform JavaScript runtime environment that executes JavaScript code outside of a web browser.",
            'React': "A JavaScript library for building user interfaces, developed by Facebook, known for its declarative and component-based approach.",
            'Blockchain': "A distributed ledger technology that enables secure and transparent peer-to-peer transactions across a network.",
            'Cryptocurrency': "A digital or virtual currency that uses cryptography for security and operates independently of a central bank.",
            'Cryptography': "Cryptography is the practice of developing and using coded algorithms to protect and obscure transmitted information.",
            'SHA-256': "A cryptographic hash function used in the creation of Bitcoin addresses and in many other cryptographic applications as encryption method.",
            'IPFS': "IPFS, or InterPlanetary File System, is a decentralized protocol for storing and sharing hypermedia content. It assigns unique cryptographic hashes to content, making it immutable and facilitating efficient retrieval. Content is distributed across a network of peers, promoting resilience to censorship and data loss. IPFS has various use cases, including hosting websites, sharing files, and building decentralized applications (dApps).",
            'WEB3': "Web3 (also known as Web 3.0) is an idea for a new iteration of the World Wide Web which incorporates concepts such as decentralization, blockchain technologies, and token-based economics"
        },

        languages_frameworks: [nodejs, reactjs, ipfs],
    },
    {
        date: 'May 2023',
        icon: 'graduation-cap',
        location: 'University Name',
        title: 'P2P Energy System',
        description: 'P2P Energy System using C# & ActressMAS Framework, evaluating two different protocols such as "Double Auction" & "Second-Bid Auction".',
        imgUrl: proj12Imagen,
        technologies: ['C#', 'P2P', 'Energy System', 'ActressMAS Framework', 'Double Auction Protocol','Second-Bid Auction Protocol'],
        tech_definitions: {
            'C#': "A versatile and object-oriented programming language developed by Microsoft, commonly used for developing video-games, web applications, and desktop software.",
            'P2P': "Peer-to-peer (P2P) networking is a decentralized communication model where each participant in the network has equal privileges and responsibilities, allowing for direct communication and resource sharing between individual nodes.",
            'Energy System': "A system that manages the generation, distribution, and consumption of energy resources, including electricity, gas, and renewable energy sources, to meet the needs of users or consumers.",
            'ActressMAS Framework': "A framework for developing multi-agent systems (MAS) in C#, providing tools and libraries for modeling, simulating, and analyzing complex systems composed of autonomous agents.",
            'Double Auction Protocol': "A type of auction mechanism where both buyers and sellers submit bids and offers, and transactions occur when the bid and ask prices match.",
            'Second-Bid Auction Protocol': "An auction mechanism where participants submit sealed bids, and the highest bidder wins the item but pays the price submitted by the second-highest bidder.",
        },
        languages_frameworks: [csharp],
        additionalLinks: [
            {
                url: "https://github.com/Carlosjr5/P2P-EnergySystem.git",
                text: "Github Repo",
            },

        ],
    },
    {
        key: '3',
        date: 'May 2022',
        icon: 'gamepad',
        location: 'Unity Game Jam',
        title: 'ChimpaQuiz Game',
        description: 'The aim of this project is to engineer a game app geared towards people of all ages in the format of a trivia questionnaire. The purpose of the project is to design a captivating experience for users to test their knowledge in multiple spheres of study and generate revenue through the means of in-app purchases and ads, developed using Unity Engine and C#, added as well created designs and sound design.',
        imgUrl: proj16Imagen,
        technologies: ['Unity', 'C#', 'Game Development', 'In-App Purchases', 'Ad Integration', 'User Experience (UX) Design', 'Sound Design', 'Cross-Platform'],
        tech_definitions: {
            'Unity': "A cross-platform game engine developed by Unity Technologies, known for its user-friendly interface and ability to create high-quality 2D and 3D games.",
            'C#': "A versatile and object-oriented programming language developed by Microsoft, commonly used for developing games, web applications, and desktop software.",
            'Game Development': "The process of creating video games, involving the design, development, and testing of interactive entertainment software.",
            'In-App Purchases': "A monetization strategy in which users can buy digital goods or content within a mobile application, enhancing their experience or providing additional features.",
            'Ad Integration': "The incorporation of advertisements into a mobile application, typically used as a revenue-generating strategy through partnerships with ad networks.",
            'User Experience (UX) Design': "The process of enhancing user satisfaction by improving the usability, accessibility, and pleasure provided in the interaction between the user and the product.",
            'Sound Design': "The art and practice of creating and manipulating audio elements, including music, sound effects, and dialogue, to enhance the overall experience of a game or multimedia project.",
        },
        languages_frameworks: [csharp, unity, firebase],

    },
    {
        key: '7',
        date: 'May 2022',
        icon: 'gamepad',
        location: 'Game Development Course',
        title: 'Game Engineeering',
        description: 'Fizh&Chips its a game that is developed using C++ and CMake engine. The code architecture includes main C++ files for game logic, with CMake managing the build process. It includes modules for graphics, user input, and game mechanics.',
        imgUrl: proj10Imagen,
        technologies: ['C++', 'CMake', 'Game Development', 'Game Engineeering', 'In-App Purchases', 'Ad Integration', 'User Experience (UX) Design'],
        tech_definitions: {
            'C++': "A powerful and versatile programming language commonly used for developing system software, game engines, and performance-critical applications.",
            'CMake': "An open-source build system used to manage the build process of software projects, providing a platform-independent way to specify and build executable programs.",
        },
          additionalLinks: [
            {
                url: " https://carlosjr23.itch.io/fizhchips",
                text: "Play Now!",
            },

        ],

        languages_frameworks: [cplus, cmake],
    },
    {
        key: '4',
        date: 'April 2021',
        icon: 'code',
        location: 'Software Company',
        title: 'Software Engineering Methods',
        description: 'I worked for an organisation that requires reporting on population information. I have been tasked with designing and implementing a new system to allow easy access to this population information. The organisation has provided an SQL database to work from in order to get details out from it using Java, filtering the results the organization wanted to get from the database using Docker.',
        imgUrl: proj3Imagen,
        technologies: ['Java', 'SQL', 'Docker', 'Database Management Systems (DBMS)', 'Data Filtering', 'System Design', 'CD/CI', 'Agile'],
        tech_definitions: {
            'Java': "A widely-used object-oriented programming language known for its platform independence, flexibility, and vast ecosystem of libraries and frameworks.",
            'SQL': "Structured Query Language, a domain-specific language used for managing and manipulating relational databases, including operations such as querying, updating, and modifying data.",
            'Docker': "An open platform for developing, shipping, and running applications in containers, allowing developers to package their applications with all dependencies into a standardized unit for easy deployment and scalability.",
            'Database Management Systems (DBMS)': "Software systems used to manage and manipulate databases, providing features such as data storage, retrieval, modification, and security.",
            'Data Filtering': "The process of selecting and retrieving specific data from a dataset based on certain criteria or conditions, often used to extract relevant information from large datasets.",
            'System Design': "The process of defining the architecture, components, modules, interfaces, and data for a system to meet specified requirements.",
            'CD/CI Integration': "Docker can be used to containerize the application, facilitating consistent deployment across different environments. CI/CD pipelines can automate testing and deployment processes.",
            'Agile Methodologies': "Agile methodologies can aid in managing changing requirements, ensuring stakeholder collaboration, and delivering value incrementally."

        },
        languages_frameworks: [java, mysql, docker],
        additionalLinks: [
            {
                url: "https://github.com/Carlosjr5/sem",
                text: "Github Repo",
            },

        ],
    }

];

export default timelineElements;